/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'extension.charts.aggregateData': 'Агрегировать данные',
  'extension.charts.aggregateDataDescription':
    'Если в нескольких строках содержатся одинаковые значения, объединять их в одну точку данных.',
  'extension.charts.category': 'Категория',
  'extension.charts.customizeTab': 'Настройка',
  'extension.charts.dataMissing.details': 'Не удается найти исходную таблицу для этой диаграммы на странице.',
  'extension.charts.dataMissing.title': 'Нет данных для отображения',
  'extension.charts.dataTab': 'Данные',
  'extension.charts.defaultColumnName': 'Столбец {0}',
  'extension.charts.defaultTitle': 'Диаграмма без названия',
  'extension.charts.defaultYLabel': 'Ось без названия',
  'extension.charts.extensionTitle': 'Диаграмма',
  'extension.charts.height': 'Высота области построения',
  'extension.charts.height.large': 'Выше',
  'extension.charts.height.medium': 'По умолчанию',
  'extension.charts.height.small': 'Ниже',
  'extension.charts.horizontal.orientation.label': 'Горизонтально',
  'extension.charts.insert.tooltip': 'Вставить диаграмму',
  'extension.charts.legend': 'Легенда',
  'extension.charts.legend.auto': 'Автоматически',
  'extension.charts.legend.bottom': 'Внизу',
  'extension.charts.legend.left': 'Слева',
  'extension.charts.legend.position': 'Расположение легенды',
  'extension.charts.legend.right': 'Справа',
  'extension.charts.legend.show': 'Показать легенду',
  'extension.charts.legend.top': 'Вверху',
  'extension.charts.options.label': 'Параметры диаграммы',
  'extension.charts.options.tooltip': 'Изменить параметры диаграммы',
  'extension.charts.orientation.label': 'Ориентация',
  'extension.charts.seriesNames': 'Ряды данных',
  'extension.charts.showPoints': 'Отобразить точки данных',
  'extension.charts.smoothLines': 'Сглаженные линии',
  'extension.charts.style': 'Стиль',
  'extension.charts.title': 'Название',
  'extension.charts.type.bar': 'Гистограмма',
  'extension.charts.type.fieldDescription': 'Тип диаграммы',
  'extension.charts.type.line': 'Линейная',
  'extension.charts.type.pie': 'Круговая',
  'extension.charts.userTitle': 'Название',
  'extension.charts.vertical.orientation.label': 'Вертикально',
  'extension.charts.xAxis': 'Ось X',
  'extension.charts.xLabel': 'Метка оси X',
  'extension.charts.yLabel': 'Метка оси Y',
};
